function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import { FormattedMessage, useIntl } from 'react-intl';
import { SongRequestPlaylist } from '@/types/server';
import { clearSongRequestPlaylist, createPlaylistItem, deletePlaylistItem, getPlaylist, getSongRequestSettings, importPlaylistFromUrl } from '@/actions/SongRequestActions';
import useChannelStore from '@/stores/ChannelStore';
import InputModal, { DefaultInput } from '@/components/InputModal';
import { useNavigate } from 'react-router';
import { WebRoutes } from '@/utils/constants';
import Heading from '../Heading';
import { Helmet } from 'react-helmet';
import { PlaylistSortType } from '@/types/client';
import useQueryState from '@/hooks/useQueryState';
import { parseSometimesNull, useLimitQueryState, usePageQueryState, useSortDirectionQueryState } from '@/hooks/usePaginationQueryState';
import SongSettingsMenu from '../song_requests/SongSettingsMenu';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { useDebouncedCallback } from 'use-debounce';
import PlaylistTable from '../song_requests/PlaylistTable';
import BackButton from '../BackButton';
import styles from './Playlist.module.scss';
import { useDisclosure } from '@mantine/hooks';
import { ActionIcon } from '@mantine/core';
import Icon from '../Icon';
function Playlist() {
    var navigate = useNavigate();
    var intl = useIntl();
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var _React_useState = _sliced_to_array(React.useState(false), 2), isSearching = _React_useState[0], setIsSearching = _React_useState[1];
    var _useDisclosure = _sliced_to_array(useDisclosure(), 2), addPlaylistItemModalOpen = _useDisclosure[0], addPlaylistItemModalHandlers = _useDisclosure[1];
    var _useDisclosure1 = _sliced_to_array(useDisclosure(), 2), deletePlaylistItemModalOpen = _useDisclosure1[0], deletePlaylistItemModalHandlers = _useDisclosure1[1];
    var _useDisclosure2 = _sliced_to_array(useDisclosure(), 2), importPlaylistModalOpen = _useDisclosure2[0], importPlaylistModalHandlers = _useDisclosure2[1];
    var _useDisclosure3 = _sliced_to_array(useDisclosure(), 2), clearPlaylistModalOpen = _useDisclosure3[0], clearPlaylistModalHandlers = _useDisclosure3[1];
    var _React_useState1 = _sliced_to_array(React.useState(null), 2), playlist = _React_useState1[0], setPlaylist = _React_useState1[1];
    var _useQueryState = _sliced_to_array(useQueryState('sort', {
        defaultValue: PlaylistSortType.CREATED_AT,
        parse: parseSometimesNull
    }), 2), playlistSortType = _useQueryState[0], setPlaylistSortType = _useQueryState[1];
    var _useQueryState1 = _sliced_to_array(useQueryState('search', {
        defaultValue: ''
    }), 2), playlistSearch = _useQueryState1[0], setPlaylistSearch = _useQueryState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(playlistSearch), 2), search = _React_useState2[0], setSearch = _React_useState2[1];
    var _useSortDirectionQueryState = _sliced_to_array(useSortDirectionQueryState(), 2), playlistSortDirection = _useSortDirectionQueryState[0], setPlaylistSortDirection = _useSortDirectionQueryState[1];
    var _React_useState3 = _sliced_to_array(React.useState(true), 2), playlistHasMore = _React_useState3[0], setPlaylistHasMore = _React_useState3[1];
    var _React_useState4 = _sliced_to_array(React.useState(Date.now()), 2), playlistRandomSeed = _React_useState4[0], setPlaylistRandomSeed = _React_useState4[1];
    var playlistLoadingRef = React.useRef(false);
    var _React_useState5 = _sliced_to_array(React.useState(null), 2), selectedSong = _React_useState5[0], setSelectedSong = _React_useState5[1];
    var _useLimitQueryState = _sliced_to_array(useLimitQueryState(), 2), playlistLimit = _useLimitQueryState[0], setPlaylistLimit = _useLimitQueryState[1];
    var _React_useState6 = _sliced_to_array(React.useState(0), 2), playlistTotal = _React_useState6[0], setPlaylistTotal = _React_useState6[1];
    var _usePageQueryState = _sliced_to_array(usePageQueryState(), 2), playlistPage = _usePageQueryState[0], setPlaylistPage = _usePageQueryState[1];
    var _useState = _sliced_to_array(useState(null), 2), settings = _useState[0], setSettings = _useState[1];
    React.useEffect(function() {
        if ((channel === null || channel === void 0 ? void 0 : channel._id) == null) {
            return;
        }
        getSongRequestSettings(channel._id).then(function(param) {
            var settings = param.settings;
            return setSettings(settings);
        });
    }, [
        channel === null || channel === void 0 ? void 0 : channel._id
    ]);
    var loadPlaylist = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(param) {
            var _param_search, search, _param_sortBy, sortBy, _param_sortDirection, sortDirection, _param_seed, seed, _param_limit, limit, _param_page, page, reset, _ref, newPlaylist, newOffset, total;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _param_search = param.search, search = _param_search === void 0 ? playlistSearch : _param_search, _param_sortBy = param.sortBy, sortBy = _param_sortBy === void 0 ? playlistSortType : _param_sortBy, _param_sortDirection = param.sortDirection, sortDirection = _param_sortDirection === void 0 ? playlistSortDirection : _param_sortDirection, _param_seed = param.seed, seed = _param_seed === void 0 ? playlistRandomSeed : _param_seed, _param_limit = param.limit, limit = _param_limit === void 0 ? playlistLimit : _param_limit, _param_page = param.page, page = _param_page === void 0 ? playlistPage : _param_page;
                        if (channel == null || playlistLoadingRef.current) {
                            return [
                                2
                            ];
                        }
                        reset = playlistRandomSeed !== seed;
                        if (!reset && !playlistHasMore) {
                            return [
                                2
                            ];
                        }
                        playlistLoadingRef.current = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            getPlaylist(channel._id, {
                                limit: limit,
                                offset: page * limit,
                                sort_by: sortBy !== null && sortBy !== void 0 ? sortBy : undefined,
                                q: search !== null && search !== void 0 ? search : undefined,
                                direction: sortDirection !== null && sortDirection !== void 0 ? sortDirection : undefined,
                                seed: seed
                            })
                        ];
                    case 2:
                        _ref = _state.sent(), newPlaylist = _ref.playlist, newOffset = _ref.offset, total = _ref.total;
                        setPlaylistTotal(total);
                        setPlaylistSearch(search);
                        setPlaylist(function(prev) {
                            return reset ? newPlaylist : _to_consumable_array(prev !== null && prev !== void 0 ? prev : []).concat(_to_consumable_array(newPlaylist));
                        });
                        setPlaylistHasMore(total > newOffset + newPlaylist.length);
                        setPlaylistSortDirection(sortDirection);
                        setPlaylistSortType(sortBy);
                        setPlaylistRandomSeed(seed);
                        setPlaylistLimit(limit);
                        setPlaylistPage(page);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        playlistLoadingRef.current = false;
                        setIsSearching(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        playlistSearch,
        playlistSortType,
        playlistSortDirection,
        playlistRandomSeed,
        playlistLimit,
        playlistPage,
        channel,
        playlistHasMore,
        setPlaylistSearch,
        setPlaylistSortDirection,
        setPlaylistSortType,
        setPlaylistLimit,
        setPlaylistPage
    ]);
    React.useEffect(function() {
        if ((channel === null || channel === void 0 ? void 0 : channel._id) == null) {
            return;
        }
        loadPlaylist({
            seed: Date.now()
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        channel === null || channel === void 0 ? void 0 : channel._id
    ]);
    var debouncedSearch = useDebouncedCallback(function(search) {
        loadPlaylist({
            search: search,
            page: 0,
            sortBy: null,
            seed: Date.now()
        });
    }, 500);
    function handleSearchChange(search) {
        setSearch(search);
        setIsSearching(true);
        debouncedSearch(search);
    }
    var deletePlaylist = React.useCallback(function() {
        if (channel == null || playlist == null) {
            return;
        }
        clearSongRequestPlaylist(channel._id).then(function() {
            setPlaylistHasMore(false);
            setPlaylist([]);
        });
    }, [
        channel,
        playlist
    ]);
    function addPlaylistItem(url) {
        return _addPlaylistItem.apply(this, arguments);
    }
    function _addPlaylistItem() {
        _addPlaylistItem = _async_to_generator(function(url) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (channel == null || playlist == null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            createPlaylistItem(channel._id, url)
                        ];
                    case 1:
                        _state.sent();
                        setPlaylistHasMore(true);
                        loadPlaylist({
                            seed: Date.now()
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _addPlaylistItem.apply(this, arguments);
    }
    function importPlaylist(url) {
        return _importPlaylist.apply(this, arguments);
    }
    function _importPlaylist() {
        _importPlaylist = _async_to_generator(function(url) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (channel == null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            importPlaylistFromUrl(channel._id, url)
                        ];
                    case 1:
                        _state.sent();
                        setPlaylistHasMore(true);
                        // task is async, so we need to wait a bit before loading the playlist
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 5000);
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            loadPlaylist({
                                seed: Date.now(),
                                sortBy: playlistSortType
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _importPlaylist.apply(this, arguments);
    }
    var handleOnDeleteModal = React.useCallback(function(song) {
        deletePlaylistItemModalHandlers.open();
        setSelectedSong(song);
    }, [
        deletePlaylistItemModalHandlers
    ]);
    var removePlaylistItem = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (channel == null || selectedSong == null) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        deletePlaylistItem(channel._id, selectedSong._id)
                    ];
                case 1:
                    _state.sent();
                    setPlaylist(function(prev) {
                        var _prev_filter;
                        return (_prev_filter = prev === null || prev === void 0 ? void 0 : prev.filter(function(song) {
                            return song._id !== selectedSong._id;
                        })) !== null && _prev_filter !== void 0 ? _prev_filter : [];
                    });
                    return [
                        2
                    ];
            }
        });
    }), [
        channel,
        selectedSong
    ]);
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "bv2dU7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Playlist"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(BackButton, {
                fallbackParams: WebRoutes.SONG_REQUESTS,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "3s3LJl",
                    defaultMessage: "Song Requests"
                })
            }),
            /*#__PURE__*/ _jsx(Heading, {
                subHeading: intl.formatMessage({
                    id: "7d1j0L",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Manage your playlist to fallback to when the queue is empty"
                        }
                    ]
                }),
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "bv2dU7",
                    defaultMessage: "Playlist"
                })
            }),
            /*#__PURE__*/ _jsx(PlaylistTable, {
                playlist: playlist !== null && playlist !== void 0 ? playlist : [],
                total: playlistTotal,
                page: playlistPage,
                limit: playlistLimit,
                sortType: playlistSortType,
                sortDirection: playlistSortDirection,
                afterControlsElement: (settings === null || settings === void 0 ? void 0 : settings.playlist) === SongRequestPlaylist.CHANNEL ? /*#__PURE__*/ _jsx(SongSettingsMenu, {
                    onAddPlaylistItem: addPlaylistItemModalHandlers.open,
                    onImportPlaylist: importPlaylistModalHandlers.open,
                    onClearPlaylist: clearPlaylistModalHandlers.open,
                    onEditSettings: function() {
                        return navigate(WebRoutes.SONG_REQUESTS_SETTINGS);
                    },
                    children: /*#__PURE__*/ _jsx(ActionIcon, {
                        className: styles.songRequestSettingsButton,
                        size: "lg",
                        "aria-label": intl.formatMessage({
                            id: "9GvlpZ",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Open Settings"
                                }
                            ]
                        }),
                        children: /*#__PURE__*/ _jsx(Icon, {
                            icon: faEllipsisV
                        })
                    })
                }) : undefined,
                setSort: function(type, direction) {
                    return loadPlaylist({
                        page: 0,
                        sortBy: direction == null ? null : type,
                        sortDirection: direction,
                        seed: Date.now()
                    });
                },
                isSearching: isSearching,
                search: search,
                onSearch: handleSearchChange,
                onAddPlaylistItem: (settings === null || settings === void 0 ? void 0 : settings.playlist) === SongRequestPlaylist.CHANNEL ? addPlaylistItemModalHandlers.open : undefined,
                onLimit: function(limit) {
                    return loadPlaylist({
                        limit: limit,
                        page: 0,
                        seed: Date.now()
                    });
                },
                onDeletePlaylistItem: (settings === null || settings === void 0 ? void 0 : settings.playlist) === SongRequestPlaylist.CHANNEL ? handleOnDeleteModal : null,
                onNextPage: function() {
                    return loadPlaylist({
                        page: playlistPage + 1,
                        seed: Date.now()
                    });
                },
                onPreviousPage: function() {
                    return loadPlaylist({
                        page: playlistPage - 1,
                        seed: Date.now()
                    });
                }
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: deletePlaylistItemModalOpen,
                onClose: deletePlaylistItemModalHandlers.close,
                onSubmit: removePlaylistItem,
                title: intl.formatMessage({
                    id: "95u4hh",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete Playlist Song"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "LpTTuF",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to delete this playlist song?"
                        }
                    ]
                }),
                submitText: intl.formatMessage({
                    id: "K3r6DQ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: addPlaylistItemModalOpen,
                onClose: addPlaylistItemModalHandlers.close,
                onSubmit: addPlaylistItem,
                title: intl.formatMessage({
                    id: "rppOxR",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Add Playlist Song"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "MMs3Fv",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter the song you want to add to your playlist"
                        }
                    ]
                }),
                renderInput: function(inputProps) {
                    return /*#__PURE__*/ _jsx(DefaultInput, _object_spread({
                        placeholder: intl.formatMessage({
                            id: "b6C1lG",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Song name or URL"
                                }
                            ]
                        })
                    }, inputProps));
                },
                submitText: intl.formatMessage({
                    id: "9XUYQt",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Import"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: clearPlaylistModalOpen,
                onClose: clearPlaylistModalHandlers.close,
                onSubmit: deletePlaylist,
                title: intl.formatMessage({
                    id: "t4NH/j",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Clear Playlist"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "+HpJYg",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to clear your playlist?"
                        }
                    ]
                }),
                submitText: intl.formatMessage({
                    id: "t4NH/j",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Clear Playlist"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: importPlaylistModalOpen,
                onClose: importPlaylistModalHandlers.close,
                onSubmit: importPlaylist,
                title: intl.formatMessage({
                    id: "8kO91X",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Import Playlist"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "8iQcCD",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter the playlist URL you want to import"
                        }
                    ]
                }),
                renderInput: function(inputProps) {
                    return /*#__PURE__*/ _jsx(DefaultInput, _object_spread({
                        placeholder: intl.formatMessage({
                            id: "tYwj1A",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Playlist URL"
                                }
                            ]
                        })
                    }, inputProps));
                },
                submitText: intl.formatMessage({
                    id: "9XUYQt",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Import"
                        }
                    ]
                })
            })
        ]
    });
}
export default Playlist;
